import React from "react";

function Rejectreason({status, reason}) {
  return (
    <>
      {status === "rejected" && (
        <div style={{ color: "red" }}>
         <h5  className="text-danger"> Rejected - {reason}</h5>
          <br />
        </div>
      )}
      {status === 'submitted' && (
        <div style={{ color: "red" }}>
          <h5>Submitted - waiting for admin to verify</h5>
        </div>
      )}
      {status === 'approved'&&(
        <div style={{ color: "red" }}>
          <h5><i className="fa fa-check-circle"  /> Verification Completed</h5>
        </div>
      )}

    </>
  );
}

export default Rejectreason;
